import axios from "axios";

const SaveCustomizerDesign = async (customer, value) => {
  try {
    const response = await axios({
      url: `${process.env.REACT_APP_SHOPIFY_PROXY_URL}/api/graphql`,
      method: "POST",
      data: {
        query: `mutation {
          metafieldsSet(
            metafields: [
              {
                ownerId: "${customer}",
                namespace: "integration",
                key: "customizer_designs",
                value: "${encodeURIComponent(JSON.stringify(value))}",
                type: "multi_line_text_field",
              }
            ]
          ) {
            metafields {
              key
              namespace
              value
            }
          }
        }`,
      },
    });
    if (response.data.body.data.metafieldsSet) {
      const { metafields } = response.data.body.data.metafieldsSet;
      if (metafields.length) {
        return true;
      } else {
        return false;
      }
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
};

export default SaveCustomizerDesign;
